<script lang="ts">
  import { i18n } from '../i18n/index.svelte';
  import { swipeUpDismiss } from '../gestures/swipeUpDismiss';
  import PixelIcon, { type PixelIconName } from './PixelIcon.svelte';

  interface Props {
    kind: 'success' | 'warning' | 'error' | 'info';
    message: string;
    action?: string;
    onaction?: () => void;
    ondismiss?: () => void;
  }

  let { kind, message, action, onaction, ondismiss }: Props = $props();
  const t = $derived(i18n.t);
  const icon = $derived<PixelIconName>(
    kind === 'success' ? 'check' : kind === 'error' ? 'close' : kind,
  );
</script>

<aside
  class="tst tst--{kind}"
  role={kind === 'error' ? 'alert' : 'status'}
  use:swipeUpDismiss={{ ondismiss: ondismiss ?? (() => {}) }}
>
  <span class="ico"><PixelIcon name={icon} size={48} /></span>
  <span class="tst__copy">
    <span class="ty">{kind}</span>
    <span class="msg">{message}</span>
    {#if action}<button class="tst__action" onclick={onaction}>{action}</button>{/if}
  </span>
  {#if ondismiss}
    <button
      class="tst__close"
      onclick={ondismiss}
      aria-label={t.common.ariaClose}
      data-feedback="none"
    >
      <PixelIcon name="close" size={20} />
    </button>
  {/if}
</aside>
